<template>
  <div class="page6">
    <div class="bottom"></div>
    <div class="main">
      <div class="bg"></div>
      <img @click="jump" class="back" src="../../static/img/back.png" alt="" />
      <img class="pic" src="../../static/img/stld.png" alt="" />
      <img class="name" src="../../static/img/stld-tl.png" alt="" />
      <div class="word">
        <div>
          以前，吴淞江两岸聚集了不少化工、电子企业和砂石码头，环境污染重。此外，农村生活污水随意排放问题真是很难根治。
        </div>
        <div>
          如今，苏州境内吴淞江生态廊道已长达40公里，打通了苏沪沿江一线生态长廊。生态廊道内，滨水景观道、健身慢行道、多彩线条勾勒的道路随处可见，已成为沿线居民的幸福指标。
        </div>
        <div>
          站在吴淞江的北岸，大片翻挖、平整过的土地上已经种植了各类花草、碧绿的桂花树、高大的香樟树，花卉草木高低参差、连绵成片——这里是吴淞江生态廊道，沿江各个节点的生态廊道建设，最终会串珠成链，让吴淞江更加美丽迷人。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    jump() {
      this.$router.push("/page1");
    },
  },
  mounted() {
    let Main = document.querySelector(".main");
    let MainW = Main.getBoundingClientRect().width;
    Main.style.height = (MainW / 750) * 1500 + "px";
  },
};
</script>

<style scoped>
.page6 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.page6 .bottom{
  position:absolute;
  width:100%;
  height:100%;
  top:0;
  left:0;
  background: #89d7c6;
  opacity:0.5;
}
.page6 .main {
  position: absolute;
  left: 0;
  top: -100%;
  bottom: -100%;
  margin: auto;
  width: 100%;
  height: auto;
}
.page6 .bg {
  position: absolute;
  /* width: 50%;
  height: 50%;
  background: url("../../static/img/page2-bg.jpg");
  background-size: 100% 100%;
  top:calc((100vh - 50%) / 2);
  left:calc((100vw - 50%) / 2); 
  animation: bgdh 0.5s ease-out 1;
  animation-fill-mode: forwards; */
   width: 100%;
   height: 100%;
   background: url("../../static/img/page2-bg.jpg");
   background-size: 100% 100%;
   border-radius: 50%;
   transform: scale(0.2);
   animation: bgdh 0.5s linear 1;
   animation-fill-mode: forwards;
}
.back {
   width: 10.13%;
  position: absolute;
  top: 71%;
  left: 10%;
  opacity:0;
  animation: show 2s 0.5s linear 1;
  animation-fill-mode: forwards;
}
.pic {
   width: 52.19%;
  position: absolute;
  top: 13%;
  left: 17%;
  opacity: 0;
  animation: show 2s 1.5s linear 1;
  animation-fill-mode: forwards;
}
.name {
  width: 13.07%;
  position: absolute;
  top: 12%;
  left: 74%;
  opacity:0;
  animation: show 2s 0.5s linear 1;
  animation-fill-mode: forwards;
}
.word {
  width: 67%;
  height: 24%;
  position: absolute;
  left: 16%;
  top: 61%;
  transform:rotateZ(90deg);
  /* background:gray; */
  overflow: auto;
  color: #17848b;
  text-indent: 42px;
  line-height: 28px;
  letter-spacing: 5px;
  opacity: 0;
  animation: show 2s 2s linear 1;
  animation-fill-mode: forwards;
}
@keyframes show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
/* @keyframes bgdh {
  0%{
    width: 50%;
    height: 50%;
    border-radius: 50%;
    opacity:0;
    top:calc((100vh - 50%) / 2);
    left:calc((100vw - 50%) / 2);
  }
  100%{
    width: 100%;
    height: 100%;
    border-radius: 0;
    top:0;
    left:0;
    opacity:1;
  }
} */
@keyframes bgdh {
  0%{
    border-radius: 50%;
    transform: scale(0.2)
  }
  100%{
    border-radius: 0 ;
    transform: scale(1)
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page6.vue